import { render, staticRenderFns } from "./App.vue?vue&type=template&id=d5d46ab8"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=d5d46ab8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports